module.exports = {
  encode: require( './lib/encode' ),
  decode: require( './lib/decode' ),
};
